import { axios } from "./axios";
import { env } from "../utils/env";
import { useAuth } from "../context/AuthContext";
import { useQuery } from "@tanstack/react-query";

export type ProfileRelationType = {
  id: number;
  name?: string;
  narrative?: string;
  percentage_required?: boolean;
  description_required?: boolean;
};

const fetchProfileRelationTypes =
  (authHeader: string, entityType?: number | null) => async () => {
    const url = `${env.verifyServiceUrl}individual/profile_relationship_type/`;

    const res = await axios.get(url, {
      headers: { Authorization: authHeader },
      params: {
        all: true,
        ...(entityType ? { entity_type: entityType } : {}),
      },
    });

    return res.data;
  };

export const useGetProfileRelationTypes = (entityType?: number | null) => {
  const { authHeader } = useAuth();

  /*
   * The shared axios instance carries the global response interceptor, which
   * already handles 401/403, 404 and 500/503 centrally. The hand-rolled onError
   * that used to sit here duplicated a subset of that and has been removed, so
   * a failure is not navigated twice.
   */
  return useQuery(
    ["profile_relationship_type", entityType],
    fetchProfileRelationTypes(authHeader, entityType),
    {
      retry: false,
      enabled: !!authHeader,
    },
  );
};
